var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',[_vm._v(" Loading... ")]):_c('div',[(_vm.error)?_c('div',[_vm._v(" "+_vm._s(_vm.error.response.data.message ? _vm.error.response.data.message : _vm.error.message)+" ")]):_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }